import {ErrorMessageService} from '../../../../shared/error-message.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from '../../../services/product.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-settings-create-product',
  templateUrl: './settings-create-product.component.html',
  styleUrls: ['./settings-create-product.component.scss']
})
export class SettingsCreateProductComponent implements OnInit {

  productForm: FormGroup = null;
  product_id: any = null;
  contractList: any[] = [];
  euFormList: any[] = [];

  constructor(private fb: FormBuilder, 
    private errorMessage: ErrorMessageService, 
    private activatedRoute: ActivatedRoute, 
    private router: Router, 
    private productService: ProductService,
    private http: HttpClient) {

    this.productForm = fb.group({
      contract_id: ['', Validators.required],
      eu_form_id: ['', Validators.required],
      name: ['', Validators.required],
      min: ['', Validators.required],
      max: ['', Validators.required],
      max_limit_approved: ['', Validators.required],
      weeks: ['', Validators.required],
      interest_rate: ['', Validators.required],
      late_fee_amount: ['', Validators.required],
    });

}
  ngOnInit() {
    this.getContractList();
    this.getEuFormList();
    this.activatedRoute.params.subscribe(params => {
      if(params['id']!=null){
        this.product_id = +params['id'];
        this.productService.get(this.product_id).subscribe(
          product => {
            if(Object.values(product).length){
              this.productForm.controls.contract_id.setValue(product.contract_id);
              this.productForm.controls.eu_form_id.setValue(product.eu_form_id);
              this.productForm.controls.name.setValue(product.name);
              this.productForm.controls.min.setValue(product.min);
              this.productForm.controls.max.setValue(product.max);
              this.productForm.controls.max_limit_approved.setValue(product.max_limit_approved);
              this.productForm.controls.weeks.setValue(product.weeks);
              this.productForm.controls.interest_rate.setValue(product.interest_rate);
              this.productForm.controls.late_fee_amount.setValue(product.late_fee_amount);
            }
          }
        );
      }
    });
  }

  getContractList() {
    this.http.get(environment.api_url + '/contract-templates/').subscribe(
      (response: any) => {
        this.contractList = response;
      }
    );
  }

  getEuFormList() {
    this.http.get(environment.api_url + '/euform-templates/').subscribe(
      (response: any) => {
        this.euFormList = response;
      }
    );
  }

  onFormSubmit()
  {
    if(this.product_id){
      if(this.productForm.valid){
      this.productService.edit(this.product_id, this.productForm.value).subscribe(
        resp => {
          if(resp['accepted'] === true){
            this.errorMessage.showSuccess(`El Producto ${resp.product.name} ha sido editado`);
            this.router.navigate(['/backoffice/settings/product_overview/product_list']);
          }
        }, 
        error => { 
          this.errorMessage.showError(error.error.error.show_message);
        }
      );
      }
    }else{
      if(this.productForm.valid){
      this.productService.create(this.productForm.value).subscribe(
        resp => {
          if(resp['accepted'] === true){
            this.errorMessage.showSuccess(`El Producto ${resp.product.name} ha sido creado`);
            this.productForm.reset();
          }
        }, 
        error => { 
          this.errorMessage.showError(error.error.error.show_message);
        }
      );
        }
    }
  }

  
}
